















import {Component, Vue, Watch} from 'vue-property-decorator'
import kepler from "../../../lib/kepler_sdk/kepler";

@Component({
  components: {},
})
export default class Assets extends Vue {
  public items = []
    public menuItem = null
    public drawer = null

    public routes = [
        {name: 'categories', icon: 'mdi-blur-radial'},
        {name: 'types', icon: 'mdi-blur-radial'},
        {name: 'management', icon: 'mdi-chart-gantt'},
        {name: 'vehicles', icon: 'mdi-car-multiple'},
        {name: 'notes', icon: 'mdi-note'},
        {name: 'attributes', icon: 'mdi-palette-advanced'},
        {name: 'zones', icon: 'mdi-home-map-marker'},


    ]

    public openRoute(name: string) {
        this.$router.push({name: name})
    }

}
